document.addEventListener("DOMContentLoaded", function () {
  let bundleItems = [];
  function getFreeGiftThresholdByVariantId(variantId) {
    if (!variantId || !Array.isArray(window.ctm_milestones)) return null;
    const matchedMilestone = window.ctm_milestones.find(
      (milestone) => String(milestone.variant_id) === String(variantId)
    );
    if (!matchedMilestone) return null;
    return Number(matchedMilestone.value || 0) * 100;
  }

  function syncSideCartFreeGifts(cartTotalPaise = null) {
    const template = document.querySelector("#ctm-side-cart-free-gifts-template");
    const cartItemsWrapper = document.querySelector("m-cart-drawer-items .m-cart-drawer__items");
    if (!template || !cartItemsWrapper) return;

    const resolvedCartTotal =
      cartTotalPaise !== null ? Number(cartTotalPaise) : Number(window.ctm_cart_details?.total_price || 0);

    let freeGiftContainer = cartItemsWrapper.querySelector(".free-gift-container");
    if (!freeGiftContainer) {
      freeGiftContainer = document.createElement("div");
      freeGiftContainer.className = "free-gift-container";
      cartItemsWrapper.appendChild(freeGiftContainer);
    }

    const templateWrapper = document.createElement("div");
    templateWrapper.innerHTML = template.innerHTML;
    const freeGiftItems = Array.from(templateWrapper.querySelectorAll(".ctm_cart_free_item"));
    const eligibleVariantIds = [];

    freeGiftItems.forEach((freeGiftItem) => {
      const variantId = String(freeGiftItem.dataset.variant_id || "");
      const threshold = getFreeGiftThresholdByVariantId(freeGiftItem.dataset.variant_id);
      if (threshold === null || resolvedCartTotal >= threshold) {
        eligibleVariantIds.push(variantId);
        if (!freeGiftContainer.querySelector(`.ctm_cart_free_item[data-variant_id="${variantId}"]`)) {
          freeGiftContainer.appendChild(freeGiftItem);
        }
      }
    });

    Array.from(freeGiftContainer.querySelectorAll(".ctm_cart_free_item")).forEach((freeGiftItem) => {
      const variantId = String(freeGiftItem.dataset.variant_id || "");
      if (!eligibleVariantIds.includes(variantId)) {
        freeGiftItem.remove();
      }
    });

    eligibleVariantIds.forEach((variantId) => {
      const existingItem = freeGiftContainer.querySelector(`.ctm_cart_free_item[data-variant_id="${variantId}"]`);
      if (existingItem) {
        freeGiftContainer.appendChild(existingItem);
      }
    });

    if (!freeGiftContainer.children.length) {
      freeGiftContainer.remove();
    }
  }

  // let ctm_milestones = [
  //   { value: 849, label: "₹849", sub: "Free Shipping", icon: "🚚" },
  //   { value: 1299, label: "₹1299", sub: "Free Dant Shuddhi", icon: "🎁" },
  //   { value: 2099, label: "₹2099", sub: "Free Water Testing Kit", icon: "🎁" },
  //   { value: 3099, label: "₹3099", sub: "Free Ayurmask Pollution Shield Mask", icon: "🎁" }
  // ];
  setTimeout(() => {
    let ctm_upsellswrapper = document.querySelector("m-cart-drawer .ctm_cart_upsell_wrapper");
    // if (document.querySelector(".ctm_cart_goal")) ctm_refresh_sideCart_progressBar();
    // if (document.querySelector(".ctm_cart_goal")) initCartGoal(window.ctm_milestones);
    observeCartGoal();
    if (ctm_upsellswrapper && !ctm_upsellswrapper.querySelector(".ctm_cart_upsell_products")) {
      displayCartUpsells();
    }
    const ctm_popup_overlay26 = document.querySelector(".ctm_popup_overlay");
    if (ctm_popup_overlay26) {
      const ctm_sale_popup = JSON.parse(localStorage.getItem("ctm_sale_popup"));
      if (ctm_sale_popup?.closed && ctm_sale_popup?.closed === !0) {
        ctm_popup_overlay26.style.display = "none";
      } else {
        ctm_popup_overlay26.style.display = "flex";
      }
    }
    syncSideCartFreeGifts();
    
    observeMinimogCartDrawer();
  }, 500);
  const unbrandedButton = document.querySelector(
    "button.shopify-payment-button__button.shopify-payment-button__button--unbranded"
  );
  if (unbrandedButton) {
    unbrandedButton.addEventListener("mouseenter", () => {
      unbrandedButton.classList.add("shake");
    });
    unbrandedButton.addEventListener("animationend", () => {
      unbrandedButton.classList.remove("shake");
    });
  }

  const ctmPopupExtraSectionIds = ["new_product_tabs_slider_hBxLNh"];

  function ctmFindRenderedSection(doc, sectionId) {
    return Array.from(doc.querySelectorAll('[id^="shopify-section-"]')).find((section) => {
      return section.id === `shopify-section-${sectionId}` || section.id.endsWith(`__${sectionId}`);
    });
  }

  function ctmPreparePopupSection(section) {
    const sectionClone = section.cloneNode(true);
    const scripts = Array.from(sectionClone.querySelectorAll("script[src]")).map((script) =>
      script.getAttribute("src")
    );

    sectionClone.querySelectorAll("script").forEach((script) => {
      if ((script.getAttribute("type") || "").toLowerCase() !== "application/json") {
        script.remove();
      }
    });

    return {
      html: sectionClone.outerHTML,
      scripts,
    };
  }

  function ctmExtractMainProductFromPage(html) {
    const doc = new DOMParser().parseFromString(html || "", "text/html");
    const mainProductSection =
      doc.querySelector('[data-section-type="product-page"]')?.closest('[id^="shopify-section-"]') ||
      doc.querySelector('[id^="shopify-section-template--"][id$="__main"]') ||
      doc.querySelector(".m-main-product")?.closest('[id^="shopify-section-"]');
    const sections = [];
    const usedSectionIds = new Set();

    [mainProductSection, ...ctmPopupExtraSectionIds.map((sectionId) => ctmFindRenderedSection(doc, sectionId))]
      .filter(Boolean)
      .forEach((section) => {
        if (usedSectionIds.has(section.id)) return;
        usedSectionIds.add(section.id);
        sections.push(section);
      });

    if (!sections.length) {
      return {
        html: "",
        scripts: [],
      };
    }

    return sections.reduce(
      (result, section) => {
        const preparedSection = ctmPreparePopupSection(section);
        result.html += preparedSection.html;
        result.scripts = result.scripts.concat(preparedSection.scripts);
        return result;
      },
      { html: "", scripts: [] }
    );
  }

  function ctmLoadScriptOnce(src) {
    if (!src) return Promise.resolve();
    const scriptUrl = new URL(src, window.location.origin).href;
    const existingScript = Array.from(document.scripts).find((script) => script.src === scriptUrl);

    if (existingScript) {
      return Promise.resolve();
    }

    return new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = scriptUrl;
      script.defer = true;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function ctmLoadSectionScripts(scriptUrls) {
    const uniqueScripts = Array.from(new Set(scriptUrls.filter(Boolean)));
    return uniqueScripts.reduce((promise, src) => promise.then(() => ctmLoadScriptOnce(src)), Promise.resolve());
  }

  function ctmInitPopupTabsSection(container) {
    container.querySelectorAll(".hiims-tabs").forEach((wrap) => {
      if (wrap.dataset.ctmPopupInitialized === "true") return;
      wrap.dataset.ctmPopupInitialized = "true";

      const btns = wrap.querySelectorAll(".hiims-tabs__btn");
      const panes = wrap.querySelectorAll(".hiims-tabs__pane");

      btns.forEach((btn) => {
        btn.addEventListener("click", () => {
          const targetId = btn.getAttribute("data-target");
          const pane = Array.from(panes).find((item) => item.id === targetId);

          btns.forEach((button) => button.classList.remove("is-active"));
          panes.forEach((item) => item.classList.remove("is-active"));

          btn.classList.add("is-active");
          if (pane) {
            pane.classList.add("is-active");
            pane.querySelectorAll(".swiper").forEach((swiperEl) => swiperEl.swiper?.update());
          }

          if (window.matchMedia("(max-width: 768px)").matches) {
            btn.scrollIntoView({
              behavior: "smooth",
              block: "nearest",
              inline: "center",
            });
          }
        });
      });
    });

    if (typeof Swiper === "undefined") return;

    container.querySelectorAll(".ctm_product_related").forEach((swiperEl) => {
      if (swiperEl.swiper) return;

      new Swiper(swiperEl, {
        speed: 300,
        slidesPerView: 3,
        slidesPerGroup: 1,
        loop: false,
        autoplay: { delay: 3500, disableOnInteraction: false, pauseOnMouseEnter: true },
        navigation: {
          nextEl: swiperEl.querySelector(".swiper-button-next"),
          prevEl: swiperEl.querySelector(".swiper-button-prev"),
        },
        breakpoints: {
          320: { slidesPerView: 1.15, spaceBetween: 10 },
          768: { slidesPerView: 1.15, spaceBetween: 10 },
          1024: { spaceBetween: 10 },
        },
      });
    });

    container.querySelectorAll(".ctm_benefits_swiper_slider").forEach((swiperEl) => {
      if (swiperEl.swiper) return;

      new Swiper(swiperEl, {
        speed: 300,
        slidesPerView: 4,
        navigation: {
          nextEl: swiperEl.querySelector(".swiper-button-next"),
          prevEl: swiperEl.querySelector(".swiper-button-prev"),
        },
        breakpoints: {
          320: { slidesPerView: 1 },
          768: { slidesPerView: 1 },
          1024: {},
        },
      });
    });

    if (window.matchMedia("(max-width: 768px)").matches) {
      container.querySelectorAll(".ctm_ingredients_mobile_slider_only").forEach((swiperEl) => {
        if (swiperEl.swiper) return;

        new Swiper(swiperEl, {
          speed: 300,
          slidesPerView: 1.2,
          spaceBetween: 10,
        });
      });
    }
  }

  function ctmInitPopupProductContent(container) {
    container.querySelectorAll(".variant-slider").forEach((ctm_variant_slider) => {
      if (ctm_variant_slider.swiper || ctm_variant_slider.querySelectorAll(".swiper-slide").length <= 3) return;

      const sliderWrapper =
        ctm_variant_slider.closest('[id^="shopify-section-"], .m-product-info--wrapper, .m-main-product') || container;
      const nextEl = sliderWrapper.querySelector(".slick-next");
      const prevEl = sliderWrapper.querySelector(".slick-prev");

      const swiperOptions = {
        slidesPerView: 3,
        spaceBetween: 10,
        speed: 500,
        loop: false,
        autoplay: false,
      };

      if (nextEl && prevEl) {
        swiperOptions.navigation = {
          nextEl,
          prevEl,
        };
      }

      new Swiper(ctm_variant_slider, swiperOptions);
    });

    container.querySelectorAll('.variant-card input[type="radio"]').forEach((input) => {
      input.addEventListener("change", (event) => {
        const variantSlider = event.target.closest(".variant-slider");
        const variantCard = event.target.closest(".variant-card");
        if (!variantSlider || !variantCard) return;

        variantSlider.querySelector(".variant-card.active")?.classList.remove("active");
        variantCard.classList.add("active");

        const discountBadge = event.target.closest(".m-product-info--wrapper")?.querySelector(".discount-badge");
        const saveAmount = variantCard.querySelector(".variant-save")?.dataset.save_percent;
        if (discountBadge) discountBadge.innerHTML = saveAmount || "";
      });
    });

    ctmInitPopupTabsSection(container);
  }

  document.querySelectorAll(".ing-card")?.forEach((div) => {
    if (!div.textContent.trim()) div.style.display = "none";
  });
  let collectionImageBanner = document.querySelector(".ctm_collection_image_banner");
  if (collectionImageBanner) {
    const closestSection = collectionImageBanner.closest(".shopify-section");
    if (closestSection && window.getComputedStyle(closestSection).display !== "none") {
      const prevSection = closestSection.previousElementSibling;
      if (prevSection && prevSection.classList.contains("shopify-section-collection-banner")) {
        prevSection.style.display = "none";
      }
    }
  }
  document.addEventListener("page:loaded", function (evt) {
    setTimeout(() => {
      let ctm_upsellswrapper = document.querySelector("m-cart-drawer .ctm_cart_upsell_wrapper");
      if (ctm_upsellswrapper && !ctm_upsellswrapper.querySelector(".ctm_cart_upsell_products")) {
        displayCartUpsells();
      }
      syncSideCartFreeGifts();
    }, 500);
  });
  document.addEventListener("cart:updated", function (evt) {
    // window.ctm_cart_details = {{- cart | json -}};
    console.log("evt.detail.cart :- ", evt.detail);
    setTimeout(() => {
      // if (evt.detail.cart) ctmUpdateProgressBar(evt.detail.cart.sections);
      // /*initCartGoal(ctm_milestones)*/ if (document.querySelector(".ctm_cart_goal")) ctm_refresh_sideCart_progressBar();
      // /*initCartGoal(ctm_milestones)*/ if (document.querySelector(".ctm_cart_goal")) initCartGoal(window.ctm_milestones);
      if (evt.detail?.cart) {
        const cartTotal = evt.detail.cart.total_price / 100;
        updateCartGoal(cartTotal);
        syncSideCartFreeGifts(evt.detail.cart.total_price);
      }

      let ctm_upsellswrapper = document.querySelectorAll(
        "m-cart-drawer .ctm_cart_upsell_wrapper .ctm_cart_upsell_products"
      );
      if (ctm_upsellswrapper.length < 1) {
        displayCartUpsells();
      }
    }, 500);
  });
  document.addEventListener("product-ajax:added", function (evt) {
    setTimeout(() => {
      // ctmUpdateProgressBar(evt.detail.product.sections);
      let ctm_upsellswrapper = document.querySelectorAll(
        "m-cart-drawer .ctm_cart_upsell_wrapper .ctm_cart_upsell_products"
      );
      if (ctm_upsellswrapper.length < 1) {
        displayCartUpsells();
      }

      updateCartDetails().then(cart => {
        const cartTotal = cart.total_price ? cart.total_price / 100 : 0;
        console.log("✅ UPDATED CART:", cartTotal, cart);
        updateCartGoal(cartTotal);
        syncSideCartFreeGifts(cart.total_price);
      });

    }, 200);
    setTimeout(() => {
      let ajaxSections = evt.detail.product.sections;
      console.log("checking product-ajax:added :- ", evt.detail.product);
      const parsedDoc = new DOMParser().parseFromString(ajaxSections.ctm_pre_purchase_popup_modal, "text/html");
      const modalWrapper = parsedDoc.querySelector(".ctm_pre_purchase_modal_section_wrapper");
      if (!modalWrapper) {
        return;
      }
      const header = modalWrapper.querySelector(".ctm_pre_purchase_modal_header");
      if (header) {
        const img = header.querySelector(".ctm_pre_purchase_modal_header_image img");
        if (img && evt.detail?.product?.featured_image) {
          img.src = evt.detail.product.featured_image.url;
          img.width = evt.detail.product.featured_image.width;
          img.height = evt.detail.product.featured_image.height;
        }
        header.querySelector(".ctm_pre_purchase_modal_header_just_added_title").textContent = evt.detail.product.title;
        const productNameEl = header.nextElementSibling && header.nextElementSibling.querySelector(".ctm_product_name");
        if (productNameEl) {
          productNameEl.textContent = evt.detail.product.title;
        }
      }
      removePresaleModal();
      document.body.appendChild(modalWrapper);
      ctm_pre_purchase_modal_slider();
    }, 1000);
  });
  document.querySelectorAll(".buy_together_variants")?.forEach((variantSelect) => {
    variantSelect.addEventListener("change", (e) => {
      const selectedOption = e.target.options[e.target.selectedIndex];
      let ctmPriceWrapper = e.target
        .closest(".ctm_buy_together_item")
        .querySelector(".ctm_buy_together_item_price_wrapper");
      e.target.closest(".ctm_buy_together_item").querySelector('input.ctm_buy_together_form_id[name="id"]').value =
        selectedOption.value;
      ctmPriceWrapper.querySelector(".ctm_buy_together_item_price_regular").innerHTML =
        selectedOption.dataset.variant_regular_price;
      ctmPriceWrapper.querySelector(".ctm_buy_together_item_price_selling").innerHTML =
        selectedOption.dataset.variant_selling_price;
      ctmPriceWrapper.querySelector(".ctm_buy_together_saving_discount").innerHTML =
        selectedOption.dataset.variant_saving;
      e.target
        .closest(".ctm_buy_together_item")
        .querySelector(".ctm_buy_together_item_img img")
        .removeAttribute("srcset");
      e.target.closest(".ctm_buy_together_item").querySelector(".ctm_buy_together_item_img img").src =
        `${selectedOption.dataset.variant_image}`;
    });
  });
  function ctmUpdateProgressBar(sections) {
    const cartHtml = sections["cart-drawer"];
    const cartDom = new DOMParser().parseFromString(cartHtml, "text/html");
    const cartNewDom = cartDom.querySelector(".ctm_cart_goal");
    const currentGoalEl = document.querySelector(".m-cart-drawer__inner .ctm_cart_goal");
    if (!cartNewDom || !currentGoalEl) return;
    const oldWrapper = currentGoalEl.querySelector(".ctm_goal_progress_wrapper");
    let oldProgress = 0;
    if (oldWrapper) {
      const raw = window.getComputedStyle(oldWrapper).getPropertyValue("--progress") || "0%";
      const parsed = parseFloat(raw.replace("%", "").trim());
      oldProgress = Number.isFinite(parsed) ? parsed : 0;
    }
    currentGoalEl.innerHTML = cartNewDom.innerHTML;
    const newWrapper = currentGoalEl.querySelector(".ctm_goal_progress_wrapper");
    if (!newWrapper) return;
    const cartTotal = parseFloat(newWrapper.dataset.cartTotal || 0);
    const maxGoal = parseFloat(newWrapper.dataset.maxGoal || 1);
    const newProgress = Math.min((cartTotal / maxGoal) * 100, 100);
    if (newProgress > 100) newProgress = 100;
    console.log("Old:", oldProgress, "New:", newProgress);
    newWrapper.style.setProperty("--progress", `${oldProgress}%`);
    requestAnimationFrame(() => {
      newWrapper.style.setProperty("--progress", `${newProgress}%`);
    });
    const milestones = (newWrapper.dataset.milestones || "").split(",").map((v) => parseFloat(v));
    newWrapper.querySelectorAll(".ctm_goal_progress_steps").forEach((step, i) => {
      const milestoneVal = milestones[i];
      if (cartTotal >= milestoneVal) step.classList.add("stepActive");
      else step.classList.remove("stepActive");
    });
  }
  function animateCompletedSteps(wrapper) {
    const steps = wrapper.querySelectorAll(".ctm_goal_progress_steps");
    const activeSteps = Array.from(steps).filter((s) => s.classList.contains("stepActive"));
    if (activeSteps.length === 0) return;
    let current = 0;
    const interval = setInterval(() => {
      activeSteps.forEach((s, i) => s.classList.toggle("highlightPulse", i === current));
      current++;
      if (current >= activeSteps.length) {
        clearInterval(interval);
        setTimeout(() => {
          activeSteps.forEach((s) => s.classList.remove("highlightPulse"));
        }, 1000);
      }
    }, 1000);
  }
  function displayCartUpsells() {
    fetch(`${window.location.pathname}?sections=ctm_cart_upsell`)
      .then((response) => response.json())
      .then((data) => {
        const dataHTML = data.ctm_cart_upsell;
        let sectionHTML = new DOMParser().parseFromString(dataHTML, "text/html");
        const container = document.querySelector("m-cart-drawer-items .ctm_cart_upsell_wrapper");
        if (container) {
          container.innerHTML = sectionHTML.querySelector("#shopify-section-ctm_cart_upsell").innerHTML;
        }
          // const swiperEl = document.querySelector(".ctm_cart_upsell_products_slider");
          const swiperEl = container.querySelector(".ctm_cart_upsell_products_slider");
          if (swiperEl && !swiperEl.classList.contains("swiper-initialized")) {
            new Swiper(swiperEl, {
              slidesPerView: 1, // ✅ default for mobile
              spaceBetween: 10,
              speed: 500,
              loop: false,

              navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              },

              breakpoints: {
                480: {
                  slidesPerView: 1.2, // slight peek
                },
                768: {
                  slidesPerView: 1.5,
                },
                1024: {
                  slidesPerView: 1.9,
                }
              }
            });
          }
        })



        // const container = document.querySelector("m-cart-drawer-items .ctm_cart_upsell_wrapper");
        // if (container) {
        //   container.innerHTML = sectionHTML.querySelector("#shopify-section-ctm_cart_upsell").innerHTML;
        //   setTimeout(() => {
        //     const upsellSlider = $(".ctm_cart_upsell_products");
        //     if (upsellSlider.length) {
        //       if (!upsellSlider.hasClass("slick-initialized")) {
        //         upsellSlider.slick({
        //           arrows: !0,
        //           dots: !1,
        //           autoplay: !1,
        //           infinite: !1,
        //           slidesToShow: 1.8,
        //           slidesToScroll: 1,
        //           speed: 500,
        //           prevArrow: `<svg class="ctm_icon_left ctm_arrow_icon slick-arrow slick-prev" fill="#000000" height="25px" width="25px" version="1.1" viewBox="0 0 492 492" xml:space="preserve">
        //                   <g>
        //                     <g>
        //                       <path d="M198.608,246.104L382.664,62.04c5.068-5.056,7.856-11.816,7.856-19.024c0-7.212-2.788-13.968-7.856-19.032l-16.128-16.12    C361.476,2.792,354.712,0,347.504,0s-13.964,2.792-19.028,7.864L109.328,227.008c-5.084,5.08-7.868,11.868-7.848,19.084    c-0.02,7.248,2.76,14.028,7.848,19.112l218.944,218.932c5.064,5.072,11.82,7.864,19.032,7.864c7.208,0,13.964-2.792,19.032-7.864    l16.124-16.12c10.492-10.492,10.492-27.572,0-38.06L198.608,246.104z"/>
        //                     </g>
        //                   </g>
        //                   </svg>`,
        //           nextArrow: `<svg class="ctm_icon_right ctm_arrow_icon slick-arrow slick-next" fill="#000000" height="25px" width="25px" version="1.1" viewBox="0 0 492.004 492.004" xml:space="preserve">
        //                   <g>
        //                     <g>
        //                       <path d="M382.678,226.804L163.73,7.86C158.666,2.792,151.906,0,144.698,0s-13.968,2.792-19.032,7.86l-16.124,16.12    c-10.492,10.504-10.492,27.576,0,38.064L293.398,245.9l-184.06,184.06c-5.064,5.068-7.86,11.824-7.86,19.028    c0,7.212,2.796,13.968,7.86,19.04l16.124,16.116c5.068,5.068,11.824,7.86,19.032,7.86s13.968-2.792,19.032-7.86L382.678,265    c5.076-5.084,7.864-11.872,7.848-19.088C390.542,238.668,387.754,231.884,382.678,226.804z"/>
        //                     </g>
        //                   </g>
        //                   </svg>`,
        //           responsive: [{ breakpoint: 480, settings: { slidesToShow: 1.5, slidesToScroll: 1 } }],
        //         });
        //       }
        //     }
        //   });
        // }

      // })
      .catch((error) => console.error("Section render error:", error));
  }
  // function displayCartUpsells() {
  //   fetch(`${window.location.pathname}?sections=ctm_cart_upsell`)
  //     .then((response) => response.json())
  //     .then((data) => {
  //       const dataHTML = data.ctm_cart_upsell;
  //       let sectionHTML = new DOMParser().parseFromString(dataHTML, "text/html");

  //       const container = document.querySelector("m-cart-drawer-items .ctm_cart_upsell_wrapper");
  //       if (!container) return;

  //       const section = sectionHTML.querySelector("#shopify-section-ctm_cart_upsell");
  //       if (!section) return;

  //       container.innerHTML = section.innerHTML;
  //       setTimeout(() => {
  //         const swiperEl = container.querySelector(".ctm_cart_upsell_products_slider");
  //         if (!swiperEl) return;
  //         if (swiperEl.swiper) {
  //           swiperEl.swiper.destroy(true, true);
  //         }
  //         new Swiper(swiperEl, {
  //           slidesPerView: 2,
  //           spaceBetween: 10,
  //           speed: 500,
  //           loop: false,
  //           breakpoints: {
  //             480: {
  //               slidesPerView: 1.5,
  //             }
  //           }
  //         });

  //       }, 100);
  //     })
  //     .catch((error) => console.error("Section render error:", error));
  // }
  const targetNode = document.querySelector("m-cart-drawer.m-cart-drawer");
  if (targetNode) {
    const config = { childList: !1, attributes: !0, subtree: !1, attributeFilter: ["class"] };
    const callback = function (mutationsList, observer) {
      for (const mutation of mutationsList) {
        if (mutation.type === "attributes") {
          const el = mutation.target;
          // if (el.classList.contains("m-cart-drawer--active")) {
          //   $(".ctm_cart_upsell_products").slick("refresh");
          // }
          if (el.classList.contains("m-cart-drawer--active")) {
            // const swiperEl = document.querySelector(".ctm_cart_upsell_products_slider");
            // if (swiperEl) {
            //   if (swiperEl.swiper) {
            //     swiperEl.swiper.update();
            //   } else {
            //     new Swiper(swiperEl, {
            //       slidesPerView: 1.8,
            //       spaceBetween: 10,
            //       speed: 500,
            //       loop: false,
            //       navigation: {
            //         nextEl: ".swiper-button-next",
            //         prevEl: ".swiper-button-prev",
            //       },
            //       breakpoints: {
            //         480: {
            //           slidesPerView: 1.5,
            //         }
            //       }
            //     });
            //   }
            // }
          }
        }
      }
    };
    const ctmObserver = new MutationObserver(callback);
    ctmObserver.observe(targetNode, config);
  }
  let ctmMenuClickedCount = 0;
  document.addEventListener("click", function (e) {
    const ctmProductPopupClose = e.target.closest(".ctm-popup-close, .ctm-popup-overlay");
    if (ctmProductPopupClose) {
      const popup = ctmProductPopupClose.closest("#ctm-popup");
      popup?.classList.add("hidden");
      const popupContent = popup?.querySelector(".ctm-popup-content");
      if (popupContent) popupContent.innerHTML = "";
      return;
    }

    let ctmAccordion = e.target.closest(".pc-tab-label");
    let closeBtn = e.target.closest(".ctm_header_close");
    let variantsAddClick = e.target.closest(".ctm_var_add_btn");
    let ctmBtnUpdateMinus = e.target.closest(".ctmBtnUpdateMinus");
    let ctmBtnUpdatePlus = e.target.closest(".ctmBtnUpdatePlus");
    let subtotalArrow = e.target.closest(".subtotal_upper_arrow");
    const button = e.target.closest(".ctm_buy_button.has_default_variant");
    if (ctmAccordion) {
      if (ctmAccordion.closest(".pc-tab").classList.contains("active")) {
        ctmAccordion.closest(".pc-tab").classList.remove("active");
        return;
      }
      ctmAccordion.closest(".pc-tabs").querySelector(".pc-tab.active")?.classList.remove("active");
      ctmAccordion.closest(".pc-tab").classList.add("active");
    }
    if (variantsAddClick) {
      let ctmQuanInput = variantsAddClick
        .closest(".productVariants")
        ?.querySelector(
          ".ctm_upsell_item_variant.selected .ctm_upsell_item_variant_add_cart_btn .ctm_btn_quantity_input"
        );
      let prevSelectedVariant = variantsAddClick
        .closest(".productVariants")
        ?.querySelector(".ctm_upsell_item_variant.selected");
      prevSelectedVariant?.classList.remove("selected");
      variantsAddClick
        .closest(".productVariants")
        ?.querySelector(".ctm_upsell_item_variant_add_cart_btn.active")
        ?.classList.remove("active");
      if (ctmQuanInput) {
        ctmQuanInput.value = 1;
        ctmQuanInput.setAttribute("value", 1);
      }
      variantsAddClick.closest(".ctm_upsell_item_variant_add_cart_btn").classList.add("active");
      variantsAddClick.closest(".ctm_upsell_item_variant").classList.add("selected");
      variantsAddClick
        .closest(".ctm_item_variants_wrapper.active")
        .querySelector(".ctm_item_variants_footer .ctm_items_confirm_btn").disabled = !1;
    }
    if (ctmBtnUpdateMinus) {
      let inputMinusElemWrap = ctmBtnUpdateMinus?.closest(".ctm_upsell_item_variant_add_cart_btn");
      let buyTogetherQuantityWrap = inputMinusElemWrap.closest(".ctm_buy_together_item_quantity_wrapper");
      let inputMinusElem = inputMinusElemWrap.querySelector("input");
      inputMinusElem.value > 1
        ? (() => {
            inputMinusElem.value = Number(inputMinusElem.value) - 1;
            inputMinusElem.setAttribute("value", inputMinusElem.value);
          })()
        : (() => {
            if (buyTogetherQuantityWrap) return;
            inputMinusElemWrap.classList.remove("active");
            inputMinusElemWrap
              .closest(".ctm_item_variants_wrapper.active")
              .querySelector(".ctm_item_variants_footer .ctm_items_confirm_btn").disabled = !0;
          })();
      console.log("checking inputMinusElem.value :- ", inputMinusElem.value);
    }
    if (ctmBtnUpdatePlus) {
      let inputPlusElemWrap = ctmBtnUpdatePlus?.closest(".ctm_upsell_item_variant_add_cart_btn");
      let inputPlusElem = inputPlusElemWrap.querySelector("input");
      inputPlusElem.value = Number(inputPlusElem.value) + 1;
      inputPlusElem.setAttribute("value", Number(inputPlusElem.value) + 1);
      console.log("checking inputPlusElem.value :- ", inputPlusElem.value);
    }
    if (subtotalArrow) {
      console.log("Checking subtotalArrow :- ", subtotalArrow);
      
      const receiptBox = subtotalArrow.closest('[data-cart-subtotal]')?.querySelector(".ctm_hidden_receipt");
      console.log("checking receiptBox :- ", receiptBox);
      
      subtotalArrow.classList.toggle("active");
      receiptBox?.classList.toggle("hidden_receipt_open");
    }
    if (button) {
      e.preventDefault();
      const form = button.closest('form[action="/cart/add"]');
      if (!form) {
        console.warn("No form found for button:", button);
        return;
      }
      let SformData = {
        items: [{ id: form.querySelector('[name="id"]'), quantity: form.querySelector('[name="quantity"]') }],
      };
      customAddToCartAjax(form, button, null);
    }
    if (closeBtn) {
      let ctmCloseMainWrapper = closeBtn.closest(".ctm_upsell_items_vars_wrapper");
      let ctmCloseCurrentOpend = ctmCloseMainWrapper.querySelector(".ctm_item_variants_wrapper.active");
      ctmCloseCurrentOpend.querySelector(".ctm_upsell_item_variant.selected")?.classList.remove("selected");
      let ctmCurrentClosingInput = ctmCloseCurrentOpend.querySelector(
        ".ctm_upsell_item_variant_add_cart_btn.active .ctm_btn_quantity_input"
      );
      if (ctmCurrentClosingInput) {
        ctmCloseCurrentOpend.querySelector(
          ".ctm_upsell_item_variant_add_cart_btn.active .ctm_btn_quantity_input"
        ).value = 1;
        ctmCloseCurrentOpend
          .querySelector(".ctm_upsell_item_variant_add_cart_btn.active .ctm_btn_quantity_input")
          .setAttribute("value", 1);
        ctmCloseCurrentOpend.querySelector(".ctm_upsell_item_variant_add_cart_btn.active").classList.remove("active");
      }
      ctmCloseCurrentOpend.querySelector(".ctm_item_variants_footer .ctm_items_confirm_btn").disabled = !0;
      ctmCloseMainWrapper.classList.remove("active");
      ctmCloseCurrentOpend.classList.remove("active");
    }
    let upsellWrapper = e.target.closest(".ctm_upsell_items_vars_wrapper");
    let variantsWrapper = e.target.closest(".ctm_item_variants_wrapper");
    if (upsellWrapper && !variantsWrapper) {
      let ctmCloseCurrentOpend = upsellWrapper.querySelector(".ctm_item_variants_wrapper.active");
      let ctmCurrentClosingInput = ctmCloseCurrentOpend.querySelector(
        ".ctm_upsell_item_variant_add_cart_btn.active .ctm_btn_quantity_input"
      );
      if (ctmCurrentClosingInput) {
        ctmCloseCurrentOpend.querySelector(
          ".ctm_upsell_item_variant_add_cart_btn.active .ctm_btn_quantity_input"
        ).value = 1;
        ctmCloseCurrentOpend
          .querySelector(".ctm_upsell_item_variant_add_cart_btn.active .ctm_btn_quantity_input")
          .setAttribute("value", 1);
        ctmCloseCurrentOpend.querySelector(".ctm_upsell_item_variant_add_cart_btn.active").classList.remove("active");
      }
      ctmCloseCurrentOpend.querySelector(".ctm_item_variants_footer .ctm_items_confirm_btn").disabled = !0;
      upsellWrapper.classList.remove("active");
      variantsWrapper?.classList.remove("active");
    }
    const has_multiple_variant = e.target.closest(".ctm_buy_button.has_multiple_variant");
    if (has_multiple_variant) {
      e.preventDefault();
      let clickedProductId = has_multiple_variant.dataset.target_variants;
      let matchedVariants = has_multiple_variant
        .closest(".ctm_cart_upsell_wrapper")
        .querySelector(`.ctm_item_variants_wrapper[data-target_variants="${clickedProductId}"]`);
      if (matchedVariants) {
        matchedVariants.classList.add("active");
        matchedVariants.closest(".ctm_upsell_items_vars_wrapper").classList.add("active");
      }
    }
    let ctm_confirm_btn = e.target.closest(".ctm_items_confirm_btn");
    if (ctm_confirm_btn) {
      let mainVariant = ctm_confirm_btn
        .closest(".ctm_item_variants_wrapper")
        .querySelector(".ctm_upsell_item_variant.selected");
      console.log("checking the mainVariant.dataset :- ", mainVariant.dataset.variant_id);
      let mainVariantData = {
        items: [
          {
            id: mainVariant.dataset.variant_id,
            quantity: mainVariant.querySelector(".ctm_upsell_item_variant_add_cart_btn.active .ctm_btn_quantity_input")
              .value,
            properties: { _is_store_cart_upsell_item: !0 },
          },
        ],
      };
      customAddToCartAjax(null, ctm_confirm_btn, mainVariantData);
    }
    let ctmCopyCodeElem = e.target.closest(".ctmCopybtn");
    if (ctmCopyCodeElem) {
      let copyInput = ctmCopyCodeElem.closest(".ctmCopy-button")?.querySelector("#copyvalue");
      copyInput.select();
      document.execCommand("copy");
      ctmCopyCodeElem.textContent = "COPIED";
    }
    let ctmVideoTabs = e.target.closest(".ctm_featured_tab_heading");
    if (ctmVideoTabs) {
      let ctmVideoWrapper = ctmVideoTabs.dataset.video_wrapper;
      let ctmContentWrapper = ctmVideoTabs.dataset.content_wrapper;
      let ctmVideoTabsMainWrapper = ctmVideoTabs.closest(".ctm_featured_tab_videos_content_area");
      ctmVideoTabsMainWrapper?.querySelector(".ctm_featured_tab_heading.active")?.classList.remove("active");
      ctmVideoTabsMainWrapper?.querySelector(".ctm_featured_tab_video.active")?.classList.remove("active");
      ctmVideoTabsMainWrapper?.querySelector(".ctm_featured_tab_description.active")?.classList.remove("active");
      ctmVideoTabs.classList.add("active");
      ctmVideoTabsMainWrapper?.querySelector(`#${ctmVideoWrapper}`)?.classList.add("active");
      ctmVideoTabsMainWrapper?.querySelector(`#${ctmContentWrapper}`)?.classList.add("active");
    }
    let ctmQuantityUpdatePlus = e.target.closest(".ctmBundleBtnUpdatePlus");
    if (ctmQuantityUpdatePlus) {
      let ctmItemQuantityWrapper = ctmQuantityUpdatePlus.closest(".ctm_page_item_quantity_group");
      let ctmItemQuantityInput = ctmItemQuantityWrapper?.querySelector("input.ctm_bundle_quantity_input");
      let ctmItemQuantityMinus = ctmItemQuantityWrapper?.querySelector(".ctmBundleBtnUpdateMinus");
      ctmItemQuantityInput.value = Number(ctmItemQuantityInput.value) + 1;
      ctmItemQuantityInput.value > 0 ? (ctmItemQuantityMinus.disabled = !1) : (ctmItemQuantityMinus.disabled = !0);
      let bundleItem = {
        title: ctmItemQuantityInput.dataset.variant_title,
        id: ctmItemQuantityInput.dataset.variant_id,
        quantity: ctmItemQuantityInput.value,
        compare_price: ctmItemQuantityInput.dataset.variant_compare_at_price,
        price: ctmItemQuantityInput.dataset.variant_price,
        image: ctmItemQuantityInput.dataset.variant_image,
      };
      updateBundleItems(bundleItem);
    }
    let ctmQuantityUpdateMinus = e.target.closest(".ctmBundleBtnUpdateMinus");
    if (ctmQuantityUpdateMinus) {
      let ctmItemQuantityWrapper = ctmQuantityUpdateMinus.closest(".ctm_page_item_quantity_group");
      let ctmItemQuantityInput = ctmItemQuantityWrapper?.querySelector("input.ctm_bundle_quantity_input");
      ctmItemQuantityInput.value = Number(ctmItemQuantityInput.value) - 1;
      ctmItemQuantityInput.value > 0 ? (ctmQuantityUpdateMinus.disabled = !1) : (ctmQuantityUpdateMinus.disabled = !0);
      let bundleItem = {
        title: ctmItemQuantityInput.dataset.variant_title,
        id: ctmItemQuantityInput.dataset.variant_id,
        quantity: ctmItemQuantityInput.value,
        compare_price: ctmItemQuantityInput.dataset.variant_compare_at_price,
        price: ctmItemQuantityInput.dataset.variant_price,
        image: ctmItemQuantityInput.dataset.variant_image,
      };
      updateBundleItems(bundleItem);
    }
    let ctm_close_popup = e.target.closest(".ctm_close_popup");
    let ctm_popup_overlay = e.target.closest(".ctm_popup_overlay");
    if (ctm_close_popup || (ctm_popup_overlay && !e.target.closest(".ctm_popup_box"))) {
      ctm_close_popup
        ? (ctm_close_popup.closest(".ctm_popup_overlay").style.display = "none")
        : (ctm_popup_overlay.style.display = "none");
      localStorage.setItem("ctm_sale_popup", JSON.stringify({ closed: !0 }));
    }
    let modalContentClick = e.target.closest(".ctm_pre_purchase_modal_content_wrapper");
    let modalOverlayClick = e.target.closest(".ctm_pre_purchase_modal_section_wrapper");
    let modalCloseClick = e.target.closest(".ctm_icon_close");
    if (modalContentClick && !modalCloseClick) return;
    if (modalOverlayClick) modalOverlayClick.classList.remove("active");
    if (modalCloseClick && modalOverlayClick) modalOverlayClick.classList.remove("active");
    removePresaleModal();
    const isMenuOpenBtn = e.target.closest(".ctm_hamburger_menu_toggle");
    const isMenuCloseBtn = e.target.closest(".ctm_menu_close_btn");
    const isMenuBackBtn = e.target.closest(".ctm_menu_back_btn");
    const isSubMenuItem = e.target.closest(".ctm_header_sub_menu_items");
    const isMainMenuItem = e.target.closest(".ctm_mobile_header_main_item");
    if (isMenuOpenBtn) {
      isMenuOpenBtn.nextElementSibling?.classList.add("active");
    }
    if (isMenuCloseBtn) {
      const panel = isMenuCloseBtn.closest(".panel");
      const wrapper = panel?.querySelector(".ctm_mobile_header_main_wrapper");
      panel?.classList.remove("active");
      if (wrapper) {
        wrapper.querySelectorAll(".open").forEach((el) => el.classList.remove("open"));
        wrapper.querySelectorAll(".active").forEach((el) => el.classList.remove("active"));
      }
    }
    if (isMenuBackBtn) {
      const overlay = isMenuBackBtn.closest(".submenu-overlay");
      overlay?.classList.remove("active");
    }
    if (isSubMenuItem && !isMenuBackBtn) {
      document.querySelectorAll(".submenu-overlay.active").forEach((el) => el.classList.remove("active"));
      const submenuOverlay = isSubMenuItem.querySelector(".submenu-overlay");
      submenuOverlay?.classList.add("active");
    }
    if (isMainMenuItem && !isSubMenuItem && !isMenuCloseBtn) {
      const arrow = isMainMenuItem.querySelector(".ctm_menu_item_arrow");
      const content = isMainMenuItem.querySelector(".ctm_mobile_header_main_item-content");
      if (arrow?.classList.contains("open")) {
        arrow.classList.remove("open");
        content?.classList.remove("open");
      } else {
        document.querySelectorAll(".ctm_menu_item_arrow.open").forEach((el) => el.classList.remove("open"));
        document
          .querySelectorAll(".ctm_mobile_header_main_item-content.open")
          .forEach((el) => el.classList.remove("open"));
        arrow?.classList.add("open");
        content?.classList.add("open");
      }
    }
    if (e.target.closest("#mobile-menu-toggle")) {
      if (ctmMenuClickedCount % 2 === 0) {
        document.querySelector(".ctm_hamburger_menu_toggle")?.click();
        /*setTimeout(()=>{ document.querySelector(".ctm_mobile_header_main_item-title .ctm_menu_item_arrow")?.classList.add("open"); document.querySelector(".ctm_mobile_header_main_item-content")?.classList.add("open"); }, 300);*/ if (
          document.querySelector(".m-header.header-sticky-always")
        ) {
          document
            .querySelector(".ctm_mobile_header_main_wrapper.panel")
            .style.setProperty("top", `${document.querySelector(".m-header.header-sticky-always").offsetHeight}px`);
        } else {
          document
            .querySelector(".ctm_mobile_header_main_wrapper.panel")
            .style.setProperty(
              "top",
              `${Number(document.querySelector("m-header.m-header").offsetHeight) + Number(document.querySelector("section.m-announcement-bar").offsetHeight)}px`
            );
        }
      } else {
        document
          .querySelector(".ctm_menu_close_btn")
          ?.click(); /*document.querySelector(".ctm_mobile_header_main_wrapper.panel").style.setProperty("top",`unset`)*/
      }
      ctmMenuClickedCount++;
    }
    
    const ctm_openBtn = e.target.closest('.ctm_offer-bottom-right');
    const ctm_backBtn = e.target.closest('.back-btn');

    if (ctm_openBtn) {
      const ctm_offer_container = ctm_openBtn.closest('.ctm_offer-container');
      ctm_offer_container.nextElementSibling.classList.add('show');
    }
    if (ctm_backBtn) {
      ctm_backBtn.closest('.coupons-container').classList.remove('show');
    }


    const ctm_cart_view_more = e.target.closest('.view-more');
    if (ctm_cart_view_more) {
      const card = ctm_cart_view_more.closest('.card-bottom');
      const moreDetail = card.querySelector('.more-detail');
      moreDetail.classList.toggle('active');
      this.innerText = moreDetail.classList.contains('active') ? 'Hide details' : 'View more';
    }

    // const ctm_cart_offer_tab = e.target.closest(".ctm_cart_offer_tab");
    // if (ctm_cart_offer_tab) {
    //   let ctm_tabs_wrapper = ctm_cart_offer_tab?.closest('.ctm-tabs');
    //   if(ctm_tabs_wrapper) ctm_tabs_wrapper.querySelector('.ctm_cart_offer_tab.active')?.classList.remove("active");
    //   ctm_cart_offer_tab?.classList.add("active");
    //   let filter_tab = ctm_cart_offer_tab.dataset.filter;
    //   // let ctm_cart_offer_tab_content = ctm_cart_offer_tab.closest('.ctm_offer-container')?.querySelector('.content-wrapper');
    //   let ctm_cart_offer_tab_content = ctm_cart_offer_tab.closest('.coupons-container.show')?.querySelector('.content-wrapper');
    //   // ctm_cart_offer_tab_content?.querySelector(`.coupon-section.active`)?.classList.remove('active');
    //   // ctm_cart_offer_tab_content?.querySelector(`.coupon-section[data-type="${filter_tab}"]`)?.classList.add('active');
    //   // if (ctm_cart_offer_tab.dataset.filter) {
    //   // }
    //   // const el = ctm_cart_offer_tab_content.querySelector('.coupon-section.unavailable');
    //   // el.style.setProperty('display', filter_tab === 'all' ? 'block' : 'none', 'important');
    //   const sections = ctm_cart_offer_tab_content.querySelectorAll('.coupon-section');
    //   sections.forEach(section => {
    //     section.classList.remove('active');
    //     if (filter_tab === 'all') {
    //       section.style.setProperty('display', 'block', 'important');
    //     } else {
    //       if (section.dataset.type === filter_tab) {
    //         section.classList.add('active');
    //         section.style.setProperty('display', 'block', 'important');
    //       } else {
    //         section.style.setProperty('display', 'none', 'important');
    //       }
    //     }
    //   });


    //   // console.log("checking ctm_cart_offer_tab :- ", ctm_cart_offer_tab_content?.querySelector(`.coupon-section[data-type="${filter_tab}"]`))
    //   console.log("checking ctm_cart_offer_tab :- ", filter_tab, ctm_cart_offer_tab, ctm_cart_offer_tab_content?.querySelector(`.coupon-section[data-type="${filter_tab}"]`))
    // }
    const ctm_cart_offer_tab = e.target.closest(".ctm_cart_offer_tab");

    if (ctm_cart_offer_tab) {
      const wrapper = ctm_cart_offer_tab.closest('.ctm-tabs');
      wrapper?.querySelector('.ctm_cart_offer_tab.active')?.classList.remove("active");
      ctm_cart_offer_tab.classList.add("active");
      const filter_tab = ctm_cart_offer_tab.dataset.filter;
      const content = ctm_cart_offer_tab.closest('.coupons-container.show')?.querySelector('.content-wrapper');
      if (!content) return;
      const sections = content.querySelectorAll('.coupon-section');
      sections.forEach(section => {
        const type = section.dataset.type || '';
        if (filter_tab === 'all') {
          section.style.display = type === 'all' || type === 'unavailable' ? 'block' : 'none';
        } else if (type.includes(filter_tab)) {
          section.style.display = 'block';
        } else {
          section.style.display = 'none';
        }
      });
    }

    const ctm_products_details_popup_click = e.target.closest(".ctm_products_details_popup_click");
    if (ctm_products_details_popup_click) {
      const handle = ctm_products_details_popup_click.dataset.product_handle;
      // let ctm_item_offer_type = e.target.closest('.ctm_buy_together_item').dataset.ctm_item_offer_type;
      const parentItem = e.target.closest('.ctm_buy_together_item');
      // let ctm_item_offer_type = parentItem?.getAttribute('data-ctm_item_offer_type') || "true";
      window.__ctmOfferType = parentItem?.getAttribute('data-ctm_item_offer_type') || "true";
      console.log("checking ctm_products_details_popup_click :- ", window.__ctmOfferType);
      
      if (handle) {
        const ctm_products_details_popup = document.querySelector("#ctm-popup");
        const ctm_products_details_popup_content = ctm_products_details_popup?.querySelector(".ctm-popup-content");
        if (!ctm_products_details_popup || !ctm_products_details_popup_content) return;
        ctm_products_details_popup.classList.remove("hidden");
        ctm_products_details_popup_content.innerHTML = '<div class="ctm-popup-message">Loading...</div>';

        fetch(`/products/${encodeURIComponent(handle)}`)
        .then(res => res.text())
        .then(html => {
          const renderedProduct = ctmExtractMainProductFromPage(html);
          const finalHTML = renderedProduct.html;
          const scriptUrls = renderedProduct.scripts;
          
          if (!finalHTML.trim()) {
            ctm_products_details_popup_content.innerHTML = '<div class="ctm-popup-message">Product details are unavailable.</div>';
            return;
          }


          ctm_products_details_popup_content.innerHTML = finalHTML;

          const tabs__nav = ctm_products_details_popup_content.querySelector(".hiims-tabs__nav");
          // const observer = new MutationObserver(() => {
          //   console.log("checking properties MutationObserver :- ")
          //   const form = ctm_products_details_popup_content.querySelector('product-form form[action="/cart/add"]');
          //   const formCheck = ctm_products_details_popup_content.querySelectorAll('product-form form[action="/cart/add"]');
          //   console.log("FORM IMMEDIATELY AFTER HTML:", formCheck);
          //   if (!form) return;

          //   const key = window.__ctmOfferType?.trim();
          //   if (!key) return;

          //   // remove old dynamic properties (optional)
          //   form.querySelectorAll('input[name^="properties["]').forEach(el => {
          //     if (el.name !== `properties[${key}]`) {
          //       el.remove();
          //     }
          //   });

          //   let input = form.querySelector(`input[name="properties[${key}]"]`);

          //   if (!input) {
          //     input = document.createElement("input");
          //     input.type = "hidden";
          //     form.appendChild(input);
          //   }

          //   input.name = `properties[${key}]`;
          //   input.value = "true";

          //   observer.disconnect(); // important
          //   console.log("checking properties (optional) :- ")
          // });
          const observer = new MutationObserver(() => {
            const form = ctm_products_details_popup_content.querySelector('product-form form[action="/cart/add"]');
            if (!form) return;

            const key = window.__ctmOfferType?.trim();
            if (!key) return;

            // ✅ Remove old dynamic properties (but keep both required ones)
            form.querySelectorAll('input[name^="properties["]').forEach(el => {
              if (
                el.name !== `properties[${key}]` &&
                el.name !== `properties[_custom_sections_popup_sale]`
              ) {
                el.remove();
              }
            });

            // ✅ Dynamic property (existing one)
            let input = form.querySelector(`input[name="properties[${key}]"]`);
            if (!input) {
              input = document.createElement("input");
              input.type = "hidden";
              form.appendChild(input);
            }
            input.name = `properties[${key}]`;
            input.value = "true";

            // ✅ NEW property
            let popupSaleInput = form.querySelector(`input[name="properties[_custom_sections_popup_sale]"]`);
            if (!popupSaleInput) {
              popupSaleInput = document.createElement("input");
              popupSaleInput.type = "hidden";
              form.appendChild(popupSaleInput);
            }
            popupSaleInput.name = `properties[_custom_sections_popup_sale]`;
            popupSaleInput.value = "true";

            observer.disconnect();
          });

          observer.observe(ctm_products_details_popup_content, {
            childList: true,
            subtree: true
          });
          // ctm_item_offer_type
          // let ctm_popup_form = ctm_products_details_popup_content.querySelector(`form[action="/cart/add"]`);
          // if (ctm_popup_form && ctm_item_offer_type) {
          //   let existingInput = ctm_popup_form.querySelector(
          //     'input[name="properties[ctm_item_offer_type]"]'
          //   );
          //   if (!existingInput) {
          //     let input = document.createElement("input");
          //     input.type = "hidden";
          //     input.name = "properties[ctm_item_offer_type]";
          //     input.value = "true";
          //     ctm_popup_form.appendChild(input);
          //   }
          // }
          // console.log("checking ctm_popup_form, existingInput :- ", ctm_popup_form, existingInput)
          
          if (!tabs__nav) return;

          const allButtons = tabs__nav.querySelectorAll(".hiims-tabs__btn");

          // only visible buttons
          const visibleButtons = Array.from(allButtons).filter(btn => btn.offsetParent !== null);
          console.log("checking visibleButtons :- ", visibleButtons);
          const section = ctm_products_details_popup_content.querySelector(
            '[id^="shopify-section-template--"][id*="__new_product_tabs_slider"]'
          );
          if (section) {
            const tabsWrapper = tabs__nav.closest(".hiims-tabs");
            const allPanes = tabsWrapper.querySelectorAll(".hiims-tabs__pane");
            if (visibleButtons.length > 1) {
              section.style.display = "";
              const btn = visibleButtons[0];
              const target = btn.dataset.target;
              allButtons.forEach(b => b.classList.remove("is-active"));
              allPanes.forEach(p => p.classList.remove("is-active"));
              btn.classList.add("is-active");
              const activePane = tabsWrapper.querySelector(`#${target}`);
              if (activePane) activePane.classList.add("is-active");
              console.log("checking visibleButtons clicked :- ", btn);
            } else if (visibleButtons.length === 1) {
              const btn = visibleButtons[0];
              const target = btn.dataset.target;
              if (target === "product_page_disease") {
                section.style.display = "none";
              } else {
                section.style.display = "";
                allButtons.forEach(b => b.classList.remove("is-active"));
                allPanes.forEach(p => p.classList.remove("is-active"));
                btn.classList.add("is-active");
                const activePane = tabsWrapper.querySelector(`#${target}`);
                if (activePane) activePane.classList.add("is-active");
              }

            } else {
              section.style.display = "none";
            }
          }

          // ctm_products_details_popup_content.innerHTML = finalHTML;
          // console.log("ctm_products_details_popup_content :- ", ctm_products_details_popup_content.querySelector('.hiims-tabs__nav'))

          // const tabs__nav = ctm_products_details_popup_content.querySelector(".hiims-tabs__nav");
          // if (!tabs__nav) return;

          // const buttons = tabs__nav.querySelectorAll(".hiims-tabs__btn");
          // const section = ctm_products_details_popup_content.querySelector('[id^="shopify-section-template--"][id*="__new_product_tabs_slider"]');
          
          // if (section) {
          //   if (buttons.length > 1) {
          //     section.style.display = "";
          //   } else if (buttons.length === 1) {
          //     const btn = buttons[0];
          //     const target = btn.getAttribute("data-target");
          //     if (target === "product_page_disease") {
          //       section.style.display = "none";
          //     }
          //   } else {
          //     section.style.display = "none";
          //   }
          // }

          ctmLoadSectionScripts(scriptUrls)
            .then(() => {
              ctmInitPopupProductContent(ctm_products_details_popup_content)
              // let ctm_popup_form = ctm_products_details_popup_content.querySelector('form[action="/cart/add"]');
              // if (ctm_popup_form && ctm_item_offer_type) {
              //   let existingInput = ctm_popup_form.querySelector('input[name="properties[ctm_item_offer_type]"]');
              //   if (existingInput) {
              //     existingInput.value = "true";
              //   } else {
              //     const input = document.createElement("input");
              //     input.type = "hidden";
              //     input.name = "properties[ctm_item_offer_type]";
              //     input.value = "true";
              //     ctm_popup_form.appendChild(input);
              //   }

              //   console.log("✅ Property added to popup form:", ctm_popup_form);
              // }
            })
            .catch((err) => {
              console.error(err);
              ctmInitPopupProductContent(ctm_products_details_popup_content);
            });
        })
        .catch(err => {
          console.error(err);
          ctm_products_details_popup_content.innerHTML = '<div class="ctm-popup-message">Failed to load product.</div>';
        });
      }
    }
    
  });

  
    if (window.innerWidth < 768) {
      const stores_locators_sliderElem = document.querySelector(".stores_locators_slider");
      const stores_locators_slider = new Swiper(stores_locators_sliderElem, {
        slidesPerView: 1,
        spaceBetween: 16,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        breakpoints: {
          768: {
            slidesPerView: 3,
            enabled: false
          }
        }
      });
      
      console.log("stores_locators_slider :- ", stores_locators_slider);
    }


  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      document.querySelector(".ctm_pre_purchase_modal_section_wrapper.active")?.classList.remove("active");
      document.querySelector("#ctm-popup:not(.hidden)")?.classList.add("hidden");
      removePresaleModal();
    }
  });
  function customAddToCartAjax(form = null, button = null, itemData = null) {
    let formItemData;
    if (button) button.classList.add("m-spinner-loading");
    if (form) {
      const formData = new FormData(form);
      let properties = {};
      const formObj = Object.fromEntries(formData.entries());
      formItemData = {
        id: formObj.id,
        quantity: formObj.quantity || 1,
        properties: { [`_${form.dataset.form_product_type}`]: !0 },
      };
      console.log("checking formObj :- ", formObj, formItemData);
    }
    if (itemData) {
      formItemData = itemData;
    }
    const params = new URLSearchParams({ sections: "cart-drawer,ctm_pre_purchase_popup_modal" });
    fetch(`/cart/add.js?${params.toString()}`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(formItemData),
    })
      .then((res) => res.json())
      .then((res) => {
        // ctmUpdateProgressBar(res.sections);
        let ctmCartAddedResponse = null;
        if (Array.isArray(res.items) && res.items.length) {
          ctmCartAddedResponse = { ...res.items[0], sections: res.sections || {} };
        }
        document.dispatchEvent(
          new CustomEvent("product-ajax:added", { detail: { product: ctmCartAddedResponse || res } })
        );
        let mCartDrawer = document.querySelector("m-cart-drawer.m-cart-drawer");
        if (button) button.classList.remove("m-spinner-loading");
        if (button.classList.contains("ctm_items_confirm_btn")) {
          const mainBtnWrapper = button.closest(".ctm_upsell_items_vars_wrapper.active");
          if (mainBtnWrapper) {
            const activeVariant = mainBtnWrapper.querySelector(
              ".ctm_item_variants_wrapper.active .ctm_upsell_item_variant.selected"
            );
            if (activeVariant) {
              activeVariant.classList.remove("selected");
              activeVariant.querySelector(".ctm_upsell_item_variant_add_cart_btn")?.classList.remove("active");
            }
            mainBtnWrapper.querySelector(".ctm_item_variants_wrapper.active")?.classList.remove("active");
            mainBtnWrapper.classList.remove("active");
          }
          button.disabled = !0;
        }
        let dataHtml = new DOMParser().parseFromString(res.sections["cart-drawer"], "text/html");
        let cartDrawerDom = mCartDrawer.querySelector(".m-cart-drawer__items");
        if (mCartDrawer && mCartDrawer.classList.contains("m-cart-drawer--active")) {
          document.querySelector("m-cart-drawer.m-cart-drawer .m-cart-drawer__items").innerHTML =
            dataHtml.querySelector("m-cart-drawer.m-cart-drawer .m-cart-drawer__items").innerHTML;
          document.querySelector("m-cart-drawer.m-cart-drawer .m-cart__summary.m-cart-drawer__summary").innerHTML =
            dataHtml.querySelector("m-cart-drawer.m-cart-drawer .m-cart__summary.m-cart-drawer__summary").innerHTML;
        } else {
          const newCartDrawer = dataHtml.querySelector("m-cart-drawer.m-cart-drawer");
          const oldCartDrawer = document.querySelector("m-cart-drawer.m-cart-drawer");
          if (newCartDrawer && oldCartDrawer) {
            oldCartDrawer.replaceWith(newCartDrawer);
            oldCartDrawer.classList.add("m-cart-drawer--active");
            setTimeout(() => {
              let ctmCartDrawerActive = document.querySelector("m-cart-drawer.m-cart-drawer");
              ctmCartDrawerActive.classList.add("m-cart-drawer--active");
              ctmCartDrawerActive.style.setProperty("--m-bg-opacity", "0.5");
              const innerDrawer = ctmCartDrawerActive?.querySelector(".m-cart-drawer__inner");
              if (innerDrawer) {
                innerDrawer.style.setProperty("--al-thickness", "3px");
                innerDrawer.style.setProperty("--al-color", "gray");
                innerDrawer.style.setProperty("--al-start-duration", "1000ms");
                innerDrawer.style.setProperty("--al-finish-duration", "300ms");
                innerDrawer.style.setProperty("--translate-x", "0");
                innerDrawer.style.setProperty("--al-end-width", "351.406px");
              }
            }, 250);
          }
        }
        displayCartUpsells();
        fetch("/cart.js")
          .then((res) => res.json())
          .then((cart) => {
            console.log("checking cart :- ", cart);
            document.querySelectorAll(".m-cart-icon-bubble")?.forEach((cartIcon) => {
              cartIcon.querySelector(".m-cart-count-bubble.m-cart-count").innerHTML = cart.item_count;
              cartIcon.querySelector(".m-cart-count-bubble.m-cart-count")?.classList.remove("m:hidden");
            });
            return cart;
          });
        document.querySelector("m-cart-drawer")?.classList.add("m-cart-drawer--active");
      })
      .catch((err) => console.error("❌ Error adding to cart:", err));
  }
  function updateBundleItems(item) {
    const existingIndex = bundleItems.findIndex((i) => i.id === item.id);
    if (Number(item.quantity) === 0) {
      if (existingIndex !== -1) {
        bundleItems.splice(existingIndex, 1);
      }
      console.log("Updated bundleItems:", bundleItems);
      return;
    }
    existingIndex !== -1 ? (bundleItems[existingIndex].quantity = item.quantity) : bundleItems.push(item);
    console.log("Updated bundleItems:", bundleItems);
  }
  document.querySelectorAll('input[type="radio"][name="ctm_tabs"]')?.forEach((input) => {
    input.addEventListener("change", function (evt) {
      evt.preventDefault();
      let ctmTabsMainWrapper = evt.target.closest(".ctm_tabs_wrapper");
      ctmTabsMainWrapper.querySelector(".ctm_tabs_tab.active")?.classList.remove("active");
      ctmTabsMainWrapper.querySelector(".ctm_tabs_content.active")?.classList.remove("active");
      evt.target.nextElementSibling.classList.add("active");
      ctmTabsMainWrapper.querySelector(`#${evt.target.dataset.target_panel_id}`)?.classList.add("active");
    });
  });
  const metaBlock = document.querySelector(".main-product__block-meta");
  const metaList = metaBlock?.querySelector(".m-product-meta");
  if (metaList)
    if (!metaList.innerHTML.trim()) {
      metaBlock.style.display = "none";
    }
  const diseaseRelatedSwiper = new Swiper(".ctm_product_related", {
    speed: 300,
    slidesPerView: 3,
    slidesPerGroup: 1,
    loop: !1,
    autoplay: { delay: 3500, disableOnInteraction: !1, pauseOnMouseEnter: true },
    navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
    breakpoints: {
      320: { slidesPerView: 1.15, spaceBetween: 10 },
      768: { spaceBetween: 10, slidesPerView: 1.15 },
      1024: { spaceBetween: 10 },
    },
  });
  const stickyTarget = document.querySelector(".ctm_page_items_added_wrapper");
  if (!stickyTarget) return;
  const originalOffsetTop = stickyTarget.offsetTop;
  function checkSticky() {
    const scrollY = window.scrollY || window.pageYOffset;
    const viewportBottom = scrollY + window.innerHeight;
    if (viewportBottom < originalOffsetTop) {
      if (!stickyTarget.classList.contains("ctm_is_sticky")) {
        stickyTarget.classList.add("ctm_is_sticky");
      }
    } else {
      if (stickyTarget.classList.contains("ctm_is_sticky")) {
        stickyTarget.classList.remove("ctm_is_sticky");
      }
    }
  }
  checkSticky();
  window.addEventListener("scroll", checkSticky, { passive: !0 });
  document.addEventListener("focusin", function (e) {
    const el = e.target;
    if (el.matches('input.ctm_bundle_quantity_input[type="number"]')) {
      el.setAttribute("disabled", "disabled");
      el.blur();
    }
  });
  function ctm_pre_purchase_modal_slider() {
    let ctm_pre_purchase_modal_slider = new Swiper(".ctm_pre_purchase_modal_slider", {
      slidesPerView: 2,
      autoplay: { delay: 3000, disableOnInteraction: !1, pauseOnMouseEnter: !0 },
      grid: { rows: 2 },
      spaceBetween: 10,
      breakpoints: {
        320: { slidesPerView: 1.15 },
        480: { slidesPerView: 1.15 },
        768: { slidesPerView: 1.15 },
        980: { slidesPerView: 2 },
        1280: { slidesPerView: 2 },
      },
    });
  }
  function removePresaleModal() {
    if (document.querySelector(".ctm_pre_purchase_modal_section_wrapper")) {
      document.querySelector(".ctm_pre_purchase_modal_section_wrapper")?.remove();
    }
  }
  if (document.querySelector(".ctm_herbal_juices_slider")) {
    let ctm_herbal_juices_slider = new Swiper(".ctm_herbal_juices_slider", {
      slidesPerView: 3,
      // autoplay: {
      //   delay: 3000,
      //   disableOnInteraction: false,
      //   pauseOnMouseEnter: true,
      // },
      // navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
      // grid: {
      //   rows: 2,
      // },
      spaceBetween: 10,
      // pagination: {
      //   el: ".swiper-pagination",
      //   clickable: true
      // },
      breakpoints: {
        320: {
          slidesPerView: 1.15,
          // spaceBetween: 24,
          // resistanceRatio: 0.85
        },
        480: {
          slidesPerView: 1.15,
          // spaceBetween: 24,
          // resistanceRatio: 0.85
        },
        768: {
          slidesPerView: 1.15,
          // spaceBetween: 28,
          // resistanceRatio: 0.85
        },
        980: {
          slidesPerView: 2,
          // spaceBetween: 28,
          // resistanceRatio: 0.85
        },
        1280: {
          slidesPerView: 2,
          // spaceBetween: 32,
          // resistanceRatio : 0
        },
      },
    });
  }

  // let ctm_milestones = [
  //   { value: 849, label: "₹849", sub: "Free Shipping", icon: "🚚" },
  //   { value: 1299, label: "₹1299", sub: "Free Dant Shuddhi", icon: "🎁" },
  //   { value: 2099, label: "₹2099", sub: "Free Water Testing Kit", icon: "🎁" },
  //   { value: 3099, label: "₹3099", sub: "Free Ayurmask Pollution Shield Mask", icon: "🎁" }
  // ];
  // let ctmProgressBarWrapper = document.querySelector('.ctm_cart_goal')

  // function renderSteps(wrapper, ctm_milestones) {
  //   const bar = wrapper.querySelector(".ctm_goal_bar");
  //   if (!bar) return;

  //   // ❌ remove old steps (important for re-render)
  //   bar.querySelectorAll(".ctm_goal_step").forEach(el => el.remove());

  //   // ✅ create steps
  //   ctm_milestones.forEach(item => {
  //     const step = document.createElement("div");
  //     step.className = "ctm_goal_step";
  //     step.dataset.value = item.value;

  //     step.innerHTML = `
  //       <div class="ctm_step_icon">${item.icon}</div>
  //       <div class="ctm_step_label">${item.label}</div>
  //       <div class="ctm_step_sub">${item.sub}</div>
  //     `;

  //     bar.appendChild(step);
  //   });
  // }

  // function setupDynamicSteps(wrapper) {
  //   const steps = wrapper.querySelectorAll(".ctm_goal_step");
  //   if (!steps.length) return;

  //   const values = Array.from(steps).map(step => Number(step.dataset.value));

  //   const min = Math.min(...values);
  //   const max = Math.max(...values);

  //   steps.forEach((step, index) => {
  //     const value = Number(step.dataset.value);

  //     let percent = ((value - min) / (max - min)) * 100;
  //     percent = Math.max(2, Math.min(percent, 98));

  //     step.style.left = percent + "%";

  //     step.classList.remove("ctm_first", "ctm_last");
  //     if (index === 0) step.classList.add("ctm_first");
  //     if (index === steps.length - 1) step.classList.add("ctm_last");
  //   });
  // }

  // function initCartGoal(ctm_milestones) {
  //   const wrapper = document.querySelector(".ctm_cart_goal");
  //   if (!wrapper) return;

  //   renderSteps(wrapper, ctm_milestones);
  //   setupDynamicSteps(wrapper);
  // }

  // initCartGoal(ctm_milestones);

  // function setupDynamicSteps(wrapper) {
  //   const steps = wrapper.querySelectorAll(".ctm_goal_step");
  //   if (!steps.length) return;

  //   // ✅ Get all milestone values dynamically
  //   const values = Array.from(steps).map(step => Number(step.dataset.value));

  //   const min = Math.min(...values);
  //   const max = Math.max(...values);

  //   steps.forEach((step, index) => {
  //     const value = Number(step.dataset.value);

  //     // ✅ Dynamic percentage based on min → max
  //     let percent = ((value - min) / (max - min)) * 100;

  //     // Safety spacing (avoid edge breaking)
  //     percent = Math.max(2, Math.min(percent, 98));

  //     step.style.left = percent + "%";

  //     // First & last fix
  //     step.classList.remove("ctm_first", "ctm_last");
  //     if (index === 0) step.classList.add("ctm_first");
  //     if (index === steps.length - 1) step.classList.add("ctm_last");
  //   });
  // }

  // function ctm_refresh_sideCart_progressBar() {
  //   fetch(`${window.location.pathname}?sections=ctm_cart_goals_new`)
  //     .then((res) => res.json())
  //     .then((data) => {
  //       const parser = new DOMParser();
  //       const doc = parser.parseFromString(data.ctm_cart_goals_new, "text/html");
  //       const section = doc.body.firstElementChild;
  //       document.body.appendChild(section);
  //       section.querySelectorAll("script").forEach((oldScript) => {
  //         const newScript = document.createElement("script");
  //         if (oldScript.src) {
  //           newScript.src = oldScript.src;
  //         } else {
  //           newScript.textContent = oldScript.textContent;
  //         }
  //         document.body.appendChild(newScript);
  //       });
  //     });
  // }

  // function renderSteps(wrapper, milestones) {
  //   const bar = wrapper.querySelector(".ctm_goal_bar");
  //   if (!bar) return;
  //   if (bar.querySelector(".ctm_goal_step")) return;
  //   milestones.forEach(item => {
  //     const step = document.createElement("div");
  //     step.className = "ctm_goal_step";
  //     step.dataset.value = item.value;
  //     step.innerHTML = `
  //       <div class="ctm_step_icon">${item.icon}</div>
  //       <div class="ctm_step_label">${item.label}</div>
  //       <div class="ctm_step_sub">${item.sub}</div>
  //     `;
  //     bar.appendChild(step);
  //   });
  // }

  function renderSteps(wrapper, milestones) {
    const bar = wrapper.querySelector(".ctm_goal_bar");
    if (!bar) return;

    // ✅ prevent re-creation
    if (bar.querySelector(".ctm_goal_step")) return;

    milestones.forEach(item => {
      const step = document.createElement("div");
      step.className = "ctm_goal_step";
      step.dataset.value = item.value;

      step.innerHTML = `
        <div class="ctm_step_icon">${item.icon}</div>
        <div class="ctm_step_label">${item.label}</div>
        <div class="ctm_step_sub">${item.sub}</div>
      `;

      bar.appendChild(step);
    });
  }

  // function setupDynamicSteps(wrapper) {
  //   const steps = wrapper.querySelectorAll(".ctm_goal_step");
  //   if (!steps.length) return;
  //   const values = Array.from(steps).map(step => Number(step.dataset.value));
  //   const max = Math.max(...values);
  //   steps.forEach((step, index) => {
  //     const value = Number(step.dataset.value);
  //     let percent = (value / max) * 100;
  //     percent = Math.max(2, Math.min(percent, 98));
  //     step.style.setProperty("--step-left", percent + "%");
  //     step.classList.toggle("ctm_first", index === 0);
  //     step.classList.toggle("ctm_last", index === steps.length - 1);
  //   });
  // }
  function setupDynamicSteps(wrapper) {
    const steps = wrapper.querySelectorAll(".ctm_goal_step");
    if (!steps.length) return;

    const values = Array.from(steps).map(step => Number(step.dataset.value));
    const max = Math.max(...values);

    steps.forEach((step, index) => {
      const value = Number(step.dataset.value);

      let percent = (value / max) * 100;
      // percent = Math.max(2, Math.min(percent, 98));
         if (index === 0) {
          percent = 9;
        } else if (index === steps.length - 1) {
          percent = 92;
        } else {
          percent = 8 + (value / max) * (92 - 8);
        }

        // pervetnn
      step.style.setProperty("--step-left", percent + "%");

      step.classList.toggle("ctm_first", index === 0);
      step.classList.toggle("ctm_last", index === steps.length - 1);
    });
  }

  // function updateProgressBar(wrapper, cartTotal, milestones) {
  //   const bar = wrapper.querySelector(".ctm_goal_bar");
  //   if (!bar) return;

  //   let fill = bar.querySelector(".ctm_goal_fill");
  //   if (!fill) {
  //     fill = document.createElement("div");
  //     fill.className = "ctm_goal_fill";
  //     bar.appendChild(fill);
  //   }

  //   const values = milestones.map(m => m.value);
  //   const max = Math.max(...values);

  //   // ✅ correct calculation
  //   const percent = (cartTotal / max) * 100;

  //   const clamped = Math.max(0, Math.min(percent, 100));

  //   fill.style.width = clamped + "%";
  //   console.log({ cartTotal, max, percent });
  // }
  function updateProgressBar(wrapper, cartTotal, milestones) {
    const bar = wrapper.querySelector(".ctm_goal_bar");
    if (!bar) return;

    let fill = bar.querySelector(".ctm_goal_fill");

    // ✅ create once
    if (!fill) {
      fill = document.createElement("div");
      fill.className = "ctm_goal_fill";
      fill.style.transition = "width 0.4s ease"; // smooth animation
      bar.appendChild(fill);
    }

    const max = Math.max(...milestones.map(m => m.value));

    const percent = (cartTotal / max) * 100;
    const clamped = Math.max(0, Math.min(percent, 100));

    fill.style.width = clamped + "%";
  }

  // function updateProgressText(wrapper, cartTotal, milestones) {
  //   const textEl = wrapper.querySelector(".ctm_progress_text");
  //   if (!textEl) return;

  //   // sort milestones (important)
  //   const sorted = [...milestones].sort((a, b) => a.value - b.value);

  //   // find achieved
  //   const achieved = sorted.filter(m => cartTotal >= m.value);
  //   const lastAchieved = achieved[achieved.length - 1];

  //   // find next
  //   const next = sorted.find(m => cartTotal < m.value);

  //   // 🎉 STEP 1: show congratulations
  //   if (lastAchieved) {
  //     textEl.innerText = `🎉 Congrats! You unlocked ${lastAchieved.sub}`;
  //   }

  //   // ⏳ STEP 2: after delay show next target
  //   setTimeout(() => {
  //     if (next) {
  //       const remaining = next.value - cartTotal;
  //       textEl.innerText = `Add ₹${remaining} more to unlock ${next.sub}`;
  //     } else {
  //       textEl.innerText = "🎉 All rewards unlocked!";
  //     }
  //   }, 2500); // 2.5 sec
  // }
  function updateProgressText(wrapper, cartTotal, milestones) {
    const textEl = wrapper.querySelector(".ctm_progress_text");
    if (!textEl) return;

    const sorted = [...milestones].sort((a, b) => a.value - b.value);

    const achieved = sorted.filter(m => cartTotal >= m.value);
    const lastAchieved = achieved[achieved.length - 1];

    const next = sorted.find(m => cartTotal < m.value);

    // 🎉 show unlocked reward
    if (lastAchieved) {
      textEl.innerText = `🎉 Congrats! You unlocked ${lastAchieved.sub}`;
    }

    // ⏳ show next goal after delay
    setTimeout(() => {
      if (next) {
        const remaining = next.value - cartTotal;
        textEl.innerText = `Add ₹${remaining} more to unlock ${next.sub}`;
      } else {
        textEl.innerText = "🎉 All rewards unlocked!";
      }
    }, 2000);
  }

  // function initCartGoal(ctm_milestones) {
  //   const wrapper = document.querySelector(".ctm_cart_goal");
  //   if (!wrapper) return;

  //   renderSteps(wrapper, ctm_milestones);
  //   setupDynamicSteps(wrapper);

  //   // fetch('/cart.js')
  //   // .then(res => res.json())
  //   // .then(cart => {
  //   //   const total = cart.total_price / 100;
  //   //   updateProgressBar(wrapper, total, window.ctm_milestones);
  //   //   updateProgressText(wrapper, total, window.ctm_milestones);
  //   // });
  //   const total = window.ctm_cart_details.total_price / 100;
  //   updateProgressBar(wrapper, total, window.ctm_milestones);
  //   updateProgressText(wrapper, total, window.ctm_milestones);
  // }
  // function initCartGoal(milestones) {
  //   const wrapper = document.querySelector(".ctm_cart_goal");
  //   if (!wrapper) return;

  //   renderSteps(wrapper, milestones);
  //   setupDynamicSteps(wrapper);

  //   const total = window.ctm_cart_details?.total_price
  //     ? window.ctm_cart_details.total_price / 100
  //     : 0;

  //   updateProgressBar(wrapper, total, milestones);
  //   updateProgressText(wrapper, total, milestones);
  // }
  function initCartGoal(milestones) {
    const wrapper = document.querySelector(".ctm_cart_goal");
    if (!wrapper) return;
    if (!wrapper.querySelector(".ctm_goal_bar")) {
      wrapper.innerHTML = `
        <div class="ctm_goal_wrapper">
          <p class="ctm_goal_text ctm_progress_text"></p>
          <div class="ctm_goal_bar"></div>
        </div>
      `;
    }
    renderSteps(wrapper, milestones);
    setupDynamicSteps(wrapper);
    const total = window.ctm_cart_details?.total_price
      ? window.ctm_cart_details.total_price / 100
      : 0;
    updateProgressBar(wrapper, total, milestones);
    updateProgressText(wrapper, total, milestones);
  }

  // function updateCartGoal(cartTotal) {
  //   const wrapper = document.querySelector(".ctm_cart_goal");
  //   if (!wrapper) return;

  //   updateProgressBar(wrapper, cartTotal, window.ctm_milestones);
  //   updateProgressText(wrapper, cartTotal, window.ctm_milestones);
  // }
  function updateCartGoal(cartTotal) {
    console.log("checking cartTotal in cart goal update fn :- ", cartTotal);
    
    const wrapper = document.querySelector(".ctm_cart_goal");
    if (!wrapper) return;
    if (!wrapper.querySelector(".ctm_goal_bar")) {
      wrapper.innerHTML = `
        <div class="ctm_goal_wrapper">
          <p class="ctm_goal_text ctm_progress_text"></p>
          <div class="ctm_goal_bar"></div>
        </div>
      `;
      renderSteps(wrapper, window.ctm_milestones);
      setupDynamicSteps(wrapper);
    }
    updateProgressBar(wrapper, cartTotal, window.ctm_milestones);
    updateProgressText(wrapper, cartTotal, window.ctm_milestones);
  }

  function observeCartGoal() {
    const target = document.body;
    const observer = new MutationObserver(() => {
      const wrapper = document.querySelector(".ctm_cart_goal");
      if (wrapper && !wrapper.dataset.initialized) {
        wrapper.dataset.initialized = "true";
        initCartGoal(window.ctm_milestones);
      }
    });
    observer.observe(target, { childList: true, subtree: true });
  }

  function updateCartDetails() {
    return fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        window.ctm_cart_details = cart;
        return cart;
      });
  }

  if (window.ctm_cart_details?.total_price > 0) {
    initCartGoal(window.ctm_milestones);
  }

  syncSideCartFreeGifts();

  // if(document.querySelector('.ctm_cart_goal')) setupDynamicSteps(document.querySelector('.ctm_cart_goal'));
  function observeMinimogCartDrawer() {
    const cart = document.querySelector('m-cart-drawer.m-cart-drawer');
    if (!cart) return;
    let isOpen = cart.classList.contains('m-cart-drawer--active');
    const observer = new MutationObserver(() => {
      const nowOpen = cart.classList.contains('m-cart-drawer--active');
      if (nowOpen !== isOpen) {
        isOpen = nowOpen;
        if (!nowOpen) {
          // console.log('Cart CLOSED');
          cart.querySelector(".ctm_hidden_receipt")?.classList.remove('hidden_receipt_open');
          cart.querySelector(".coupons-container")?.classList.remove('show');
        } else {
          // console.log('Cart OPEN');
          setTimeout(() => {
            const swiperEl = cart.querySelector(".ctm_cart_upsell_products_slider");
            if (swiperEl?.swiper) {
              swiperEl.swiper.update();
            }
          }, 200);
        }
      }
    });

    observer.observe(cart, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }
  
});
